@if (rangeMin !== undefined || rangeMax !== undefined) {
  @if (rangeMin !== '' || rangeMax !== '') {
    <div class="feedback display-block">
      <strong>Information :</strong>
      @if (rangeMin !== '') {
        {{ 'general.dateMinimum' | translate }}  <strong>{{ _dateMin | date : dateShort  }}</strong>
      }
      @if (rangeMax !== '') {
        {{ 'general.dateMaximum' | translate }}  <strong>{{ _dateMax | date : dateShort  }}</strong>
      }
    </div>
  }
}
@if (_dateMin !== null || _dateMax !== null) {
  <div class="feedback display-block">
     @if (_dateMin !== null && _dateMax !== null) {
      {{ 'general.plageDate' | translate }} {{ _dateMin | date : dateType === 'month' ? ['MM/y'] : dateShort }} {{ 'general.au' | translate}} {{ _dateMax | date : dateType === 'month' ? ['MM/y'] : dateShort }}
    }
    @if (_dateMin !== null && _dateMax === null) {
      {{ 'general.dateMinimum' | translate }} : {{ _dateMin | date : dateType === 'month' ? ['MM/y'] : dateShort }}
    }
    @if (_dateMin === null && _dateMax !== null) {
      {{ 'general.dateMaximum' | translate }} : {{ _dateMax | date : dateType === 'month' ? ['MM/y'] : dateShort }}
    }
  </div>
}
<ng-container >



  <div class="invalid-feedback display-block">
    @if (_min !== undefined  && _min !== null && control.value < _min) {
      <span class="feedback display-block">
        <strong>{{ 'general.minimum' | translate }} {{_min}}</strong>
      </span>
    }
    @if (_max !== undefined  && _max !== null && control.value > _max) {
      <span class="feedback display-block">
        <strong>{{ 'generale.maximum' | translate }} {{_max}}</strong>
      </span>
    }
  </div>
</ng-container>





@if ( (control && control['status'] &&  control['status'] === 'INVALID')) {
  <div class="invalid-feedback display-block">
    @if (control['errors']['email']) {
      {{ 'general.formatEmailInvalide' | translate }}
    }
    @if (control['errors']['maxlength']) {
      <ng-container>{{ 'general.nombreCaracteres' | translate }} {{control['errors']['maxlength']['actualLength']}} / {{control['errors']['maxlength']['requiredLength']}}</ng-container>
    }
    @if ( control['errors']['minlength']) {
      <ng-container>{{ 'general.nombreCaracteres' | translate }} {{control['errors']['minlength']['actualLength']}}. <strong>{{'general.minimum' | translate }} {{control['errors']['minlength']['requiredLength']}}</strong></ng-container>
    }
    @if ( control['errors']['pattern']) {
      {{ 'general.formatNonAttendue' | translate }}
    }
  </div>
}


@if (control && control['errors'] && control['errors']['trueRequired']) {
  <div class="invalid-feedback display-block">
    <span class="feedback display-block">{{ 'general.caseACocherObligatoire' | translate }}</span>
  </div>
}

